<template>
    <div>
        <tab name="3" :activity-name="activityName"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.tagName" placeholder="请输入标签名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/photo/saveTags')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.editTags.show()">创建标签</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="name" label="标签名称" show-overflow-tooltip min-width="90"></el-table-column>
                <el-table-column prop="activityName" label="演出名称" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="sort" label="序号"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/photo/saveTags')" type="text" size="small" @click="$refs.editTags.show(row)">编辑
                        </el-button>
                        <el-button v-if="$utils.have('/photo/deleteTag')" type="text" size="small" @click="del(row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <edit-tags ref="editTags" :activityId="id" :activityName="activityName" @onUpdate="getDataList"></edit-tags>
    </div>
</template>

<script>
import Tab from '../components/tab.vue'
import EditTags from './components/EditTgas.vue'
const defaultParams = {
    pageNo: 1,
    activityId: "",
    tagName: "",
}
export default {
    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },
    components: { Tab, EditTags },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                tagName: this.$route.query.tagName || "",
            },
            listLoading: true,
            activityName: this.$route.query.activityName || "",
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                activityId: this.id,
            }
            this.listLoading = true;
            this.$request({
                url: "/photo/tags",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange1 = [];
            this.datetimerange2 = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //删除
        del(id) {
            const _msg = "删除标签会清空照片与标签的关联关系，可能导致乐迷筛选困难，请谨慎操作！";
            this.$confirm(_msg, '确定要删除这条标签吗?', {
                center: true,
            }).then(() => {
                this.$request({
                    url: "/photo/deleteTag",
                    method: "POST",
                    params: {
                        tagsId: id
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.search();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            }).catch(() => {

            })
        },
    }
}
</script>

<style lang="scss" scoped>

</style>